import React, { Suspense, lazy, useMemo } from 'react';
import { usePortfolioData } from '../contexts/PortfolioDataContext';
import { getLayoutDefinition } from '../layouts/layoutRegistry';

const SitePreviewPanel = lazy(() => import('./SitePreviewPanel'));

const PortfolioSiteRenderer = () => {
  const { siteConfig, layoutKey, loading, error } = usePortfolioData();
  const layoutDefinition = getLayoutDefinition(layoutKey || siteConfig?.layoutKey);
  const LayoutComponent = layoutDefinition.component;
  const showPreviewPanel = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('preview') === '1';
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--site-bg-base)] text-[var(--site-accent-primary)]">
        Loading...
      </div>
    );
  }

  if (error && !siteConfig) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--site-bg-base)] text-red-400">
        Failed to load site configuration.
      </div>
    );
  }

  return (
    <>
      <LayoutComponent siteConfig={siteConfig} />
      {showPreviewPanel && (
        <Suspense fallback={null}>
          <SitePreviewPanel />
        </Suspense>
      )}
    </>
  );
};

export default PortfolioSiteRenderer;
